import produce from 'immer';
import { SET_SELECTED_OPTION_WITH_MDV } from '../../constants';

const initialState = {
    options: [],
    selected: null,
    modifier: 'pdp'
};

const volumeDiscountWithMDV = produce((state, action) => {
    const { type, payload } = action;

    // eslint-disable-next-line default-case
    switch (type) {
        case SET_SELECTED_OPTION_WITH_MDV:
            state.selected[payload.eanId] = payload.option;
            break;
    }
}, initialState);

export default volumeDiscountWithMDV;
